import { render } from "./GetRequirement.vue?vue&type=template&id=efd8e944&scoped=true"
import script from "./GetRequirement.vue?vue&type=script&lang=js"
export * from "./GetRequirement.vue?vue&type=script&lang=js"

import "./GetRequirement.vue?vue&type=style&index=0&id=efd8e944&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-efd8e944"

export default script